import script from "./DotsNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./DotsNavigation.vue?vue&type=script&setup=true&lang=js"

import "./DotsNavigation.vue?vue&type=style&index=0&id=2615f05e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2615f05e"]])

export default __exports__